import React, { PureComponent } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import Countdown from 'react-countdown-now';

class SMSNotificationsModal extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {
        code: '',
      },
      error: '',
      timestamp: 0,
    };
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    const { validTill } = this.props;
    if (validTill) {
      this.setState(() => ({
        timestamp: validTill * 1000,
      }));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.validTill && this.props.validTill !== prevProps.validTill) {
      this.setState(() => ({
        timestamp: this.props.validTill * 1000,
      }));
    }

    if (this.props.status !== prevProps.status && this.props.status === 403) {
      this.setState(prevState => ({
        data: {
          ...prevState.data,
          code: '',
        },
      }));
    }
  }

  onChange = e => {
    const target = e.target;

    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(e, this.state.data.code);
  };

  countDownRender = ({ minutes, seconds, completed }) => {
    if (completed) {
      return <span>Срок действия истек</span>;
    } else {
      return (
        <span>
          <FormattedMessage id="notifications.sms.modal.timer" /> {('00' + minutes).slice(-2)}:
          {('00' + seconds).slice(-2)}
        </span>
      );
    }
  };

  getPlaceholder = session => {
    const { intl } = this.props;

    if (session) {
      let placeholder = intl.formatMessage({
        id: 'notifications.sms.modal.session',
        defaultMessage: 'Session №',
      });

      placeholder += session;

      return placeholder;
    }

    return '';
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleSubmit(e);
    }
  };

  onModalOpen = () => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        code: '',
      },
    }));

    if (this.inputRef) {
      this.inputRef.focus();
    }
  };

  render() {
    const {
      isOpen,
      toggleModal,
      sessionId,
      error,
      status,
      authType,
      validTill,
      transport,
    } = this.props;
    const { code } = this.state.data;
    const { timestamp } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        onOpened={this.onModalOpen}
        centered
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>
          <FormattedMessage id="notifications.sms.modal.title" defaultMessage="Confirmation" />
        </ModalHeader>
        <Form autoComplete="off">
          <ModalBody>
            <FormGroup className={error ? 'no-margin has-error' : 'no-margin'} row>
              <Col sm="12">
                <Label htmlFor="sms_code" className="">
                  <FormattedMessage
                    id={`profile.modal.code.${authType ? authType : '1'}`}
                    defaultMessage="Enter SMS Code"
                  />
                </Label>
              </Col>
              <Col sm="12">
                <Input
                  name="code"
                  id="sms_code"
                  className="sms-notification-field"
                  maxLength={10}
                  autoFocus
                  required
                  disabled={status === 403}
                  value={code}
                  placeholder={this.getPlaceholder(sessionId)}
                  onChange={this.onChange}
                  onKeyPress={this.handleKeyPress}
                  innerRef={input => (this.inputRef = input)}
                />
                {error && <span className="sms-code-error">{error}</span>}
                {validTill && status !== 403 && (
                  <p className="session-timer-container">
                    <Countdown date={timestamp} zeroPadTime={2} renderer={this.countDownRender} />
                  </p>
                )}
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="button" className="btn-sm" color="light" onClick={toggleModal}>
              <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
            </Button>
            <Button
              className="btn-sm"
              type="button"
              color="primary"
              onClick={this.handleSubmit}
              disabled={status === 403}
            >
              <FormattedMessage id="main.confirm" defaultMessage="Confirm" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default injectIntl(SMSNotificationsModal);
